import { isAfter } from 'date-fns';
import { useTranslation } from 'next-i18next';
import { EventsListUiComponentInterface } from '../../../../../interfaces/pagebuilder';
import { useSelector } from '../../../../../reduxToolkit/typedRedux';
import { PageBuilderSettingsSection, PageBuilderSettingsTable } from '../PageBuilderSettingsTable';

interface EventsListSettingsTableInterface {
  component: EventsListUiComponentInterface;
  onChange: (c: EventsListUiComponentInterface) => void;
}

const EventsListSettingsTable = ({ component, onChange }: EventsListSettingsTableInterface) => {
  const teamEvents = useSelector(({ common }) => common.teamEvents);

  const { t } = useTranslation(['pagebuilder']);

  function getOptions(onlySelected = false) {
    return teamEvents
      ?.filter((e) => !onlySelected || component.selectAllEvents || component.eventsList.includes(e._id))
      .filter((e) => !component.hidePastEvents || isAfter(new Date(e.datetime_end), new Date()))
      .map((e) => ({ name: e.name, value: e._id }));
  }

  const settingSections: PageBuilderSettingsSection[] = [
    {
      settings: [
        {
          path: 'selectAllEvents',
          type: 'boolean',
          label: t('pagebuilder:events-list-settings.select-all'),
        },
        {
          path: 'hidePastEvents',
          type: 'boolean',
          label: t('pagebuilder:events-list-settings.hide-past'),
        },
        {
          path: 'eventsList',
          type: 'multiselect',
          label: t('pagebuilder:events-list-settings.events'),
          options: getOptions(),
          selectedOptions: getOptions(true),
          visible: component.selectAllEvents === false,
        },
        {
          path: 'openBtnText',
          type: 'text',
          label: t('pagebuilder:events-list-settings.button-text'),
        },
      ],
    },
  ];
  return <PageBuilderSettingsTable sections={settingSections} onChange={onChange} component={component} showTitleAndDescription={false} />;
};
export default EventsListSettingsTable;
